import { Component, EventEmitter, Inject, Output, OnInit } from '@angular/core';
import { BaseComponent } from '@core/base.component';
import { ICON } from '@core/util/icon';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { NavigationService } from '@services/nav/nav.service';
import { UrlService } from '@services/url/url.service';
import {
	LedgerItemType,
	TrustLedgerItem,
} from '@state/global/trust-ledger/trust_ledger.models';
import { MatterDispatch } from '@state/matter';
import {
	MatterMortgageDispatch,
	MatterMortgagesState,
} from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs/internal/Observable';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

export interface VM {
	mortgage: MatterMortgageWithAssociations;
}

export const defaultVM: VM = {
	mortgage: null,
};

@UntilDestroy()
@Component({
	selector: 'app-mortgage-drawer',
	templateUrl: './mortgage-drawer.component.html',
	standalone: false,
})
export class MortgageDrawerComponent
	extends BaseComponent<VM>
	implements OnInit
{
	public mortgage: MatterMortgageWithAssociations;

	@Output() saveDescription = new EventEmitter<string>();

	@Select(MatterMortgagesState.getMortgageWithAssociations)
	mortgageFilterFn$: Observable<(id: string) => MatterMortgageWithAssociations>;

	mortgageId: string;
	hideItemization = true;
	backUrlParams = { 'back-string': 'trust ledger' };

	description: string;
	trustLedgerItem: TrustLedgerItem;
	originalTitle: string;

	public forceErrorState = false;
	public registeredEditable = false;

	public ICON = ICON;
	private matterId: string;

	constructor(
		@Inject(DRAWER_DATA)
		public data: {
			mortgageId: string;
			matterId: string;
			trustLedgerItem: TrustLedgerItem;
		},
		private mortgageDispatch: MatterMortgageDispatch,
		private matterDispatch: MatterDispatch,
		private navService: NavigationService,
		private analytics: AnalyticsService,
	) {
		super(defaultVM);
	}

	ngOnInit(): void {
		this.mortgageId = this.data.mortgageId;
		this.matterId = this.data.matterId;
		this.mortgageFilterFn$.pipe(untilDestroyed(this)).subscribe((fn) => {
			this.mortgage = fn(this.mortgageId);

			this.VM = {
				mortgage: this.mortgage,
			};
		});
		this.trustLedgerItem = this.data.trustLedgerItem;
		this.description = this.data.trustLedgerItem.description;
		this.originalTitle = this.data.trustLedgerItem.description;
	}

	updateHideItemization(event: boolean) {
		this.analytics.logEvent(
			AnalyticsEvent.MORTGAGE_DRAWER_HIDE_ITEMIZATION_CHECKBOX_CLICK,
		);
		this.mortgageDispatch.updateMortgage(this.mortgage.id, {
			hideItemization: event,
		});
	}

	updateDescription(description: string) {
		this.analytics.logEvent(AnalyticsEvent.MORTGAGE_DRAWER_DESCRIPTION_UPDATE);
		this.description = description;
		this.matterDispatch.SetReceiptDescriptionOverride(
			this.matterId,
			this.trustLedgerItem.id,
			this.description,
		);
	}

	goToItem(trustLedgerItem: TrustLedgerItem) {
		this.analytics.logEvent(
			AnalyticsEvent.MORTGAGE_DRAWER_GO_TO_MORTGAGE_LINK_CLICK,
		);
		if (trustLedgerItem.type === LedgerItemType.MORTGAGE) {
			const url = UrlService.Matter_Mortgages_Mortgage(
				this.matterId,
				trustLedgerItem?.sourceId,
			);
			this.navService.goToUrl(url, { ...this.backUrlParams });
		}
	}
}
